import { render, staticRenderFns } from "./shipday_general_tab.vue?vue&type=template&id=cce3a932&scoped=true&"
import script from "./shipday_general_tab.vue?vue&type=script&lang=js&"
export * from "./shipday_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce3a932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cce3a932')) {
      api.createRecord('cce3a932', component.options)
    } else {
      api.reload('cce3a932', component.options)
    }
    module.hot.accept("./shipday_general_tab.vue?vue&type=template&id=cce3a932&scoped=true&", function () {
      api.rerender('cce3a932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/shipday/location/tabs/shipday_general_tab.vue"
export default component.exports